<template>
  <div class="profile__card">
    <h4 class="profile__title">Cadastre um cartão de crédito</h4>

    <p v-show="hasUpdated" class="success-form-msg">
      {{ feedbackMessage }}
      <BIconX @click="closeSuccessMessage" />
    </p>

    <p v-if="!userHasAddress" class="success-form-msg">
      Favor atualizar os dados de endereço!
    </p>

    <form v-else class="profile__form">
      <div class="profile__form-group">
        <div class="custom-form-control">
          <label>Apelido do cartão</label>
          <input
            class="form-control"
            :class="[$v.card.nickname.$error ? 'form-control-invalid' : '']"
            type="text"
            placeholder="Ex: Roxinho"
            v-model="$v.card.nickname.$model"
          />
          <div v-if="$v.card.nickname.$error">
            <p class="error" v-if="!$v.card.nickname.required">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>Nome do titular (como está no cartão)</label>
          <input
            class="form-control"
            :class="[$v.card.holder_name.$error ? 'form-control-invalid' : '']"
            type="text"
            placeholder="Ex: John Doe"
            v-model="$v.card.holder_name.$model"
          />
          <div v-if="$v.card.holder_name.$error">
            <p class="error" v-if="!$v.card.holder_name.required">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>CPF do titular</label>
          <input
            class="form-control"
            :class="[$v.card.holder_cpf.$error ? 'form-control-invalid' : '']"
            type="tel"
            placeholder="Ex: 123.321.159-55"
            v-mask="'###.###.###-##'"
            v-model="$v.card.holder_cpf.$model"
          />
          <div v-if="$v.card.holder_cpf.$error">
            <p class="error" v-if="!$v.card.holder_cpf.required">
              Campo obrigatório
            </p>
          </div>
          <div v-if="$v.card.holder_cpf.$error">
            <p class="error" v-if="!$v.card.holder_cpf.cpf">CPF inválido</p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>DDD</label>
          <input
            class="form-control"
            :class="[$v.card.area_code.$error ? 'form-control-invalid' : '']"
            type="tel"
            placeholder="Ex: 82"
            v-mask="'##'"
            v-model="$v.card.area_code.$model"
          />
          <div v-if="$v.card.area_code.$error">
            <p class="error" v-if="!$v.card.area_code.required">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>Telefone</label>
          <input
            class="form-control"
            :class="[$v.card.phone_number.$error ? 'form-control-invalid' : '']"
            type="tel"
            placeholder="Ex: 999887766"
            v-mask="'#####-####'"
            v-model="$v.card.phone_number.$model"
          />
          <div v-if="$v.card.phone_number.$error">
            <p class="error" v-if="!$v.card.phone_number.required">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>Data de nascimento do titular</label>
          <input
            class="form-control"
            :class="[
              $v.card.holder_birthdate.$error ? 'form-control-invalid' : ''
            ]"
            type="tel"
            placeholder="Ex: 01/01/1999"
            v-mask="'##/##/####'"
            v-model="$v.card.holder_birthdate.$model"
          />
          <div v-if="$v.card.holder_birthdate.$error">
            <p class="error" v-if="!$v.card.holder_birthdate.required">
              Campo obrigatório
            </p>
          </div>
          <div v-if="$v.card.holder_birthdate.$error">
            <p
              class="error"
              v-if="
                !$v.card.holder_birthdate.minAge &&
                  card.holder_birthdate.length == 10
              "
            >
              Necessário ser maior de idade
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>Numero do cartão</label>
          <input
            class="form-control"
            :class="[$v.card.number.$error ? 'form-control-invalid' : '']"
            type="tel"
            placeholder="#### #### #### ####"
            v-mask="'#### #### #### ####'"
            v-model="$v.card.number.$model"
          />
          <div v-if="$v.card.number.$error">
            <p class="error" v-if="!$v.card.number.required">
              Campo obrigatório
            </p>
          </div>

          <div v-if="$v.card.number.$error">
            <p class="error" v-if="!$v.card.number.creditCardNumber">
              Número do cartão inválido
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>Data de expiração</label>
          <input
            class="form-control"
            :class="[$v.card.expiration.$error ? 'form-control-invalid' : '']"
            type="tel"
            placeholder="Ex: 12/30"
            v-model="$v.card.expiration.$model"
            v-mask="'##/##'"
            name="expiration"
          />
          <div v-if="$v.card.expiration.$error">
            <p class="error" v-if="!$v.card.expiration.required">
              Campo obrigatório
            </p>
          </div>

          <div v-if="$v.card.expiration.$error">
            <p
              class="error"
              v-if="
                !$v.card.expiration.validExpirationDate &&
                  card.expiration.length == 5
              "
            >
              Data inválida
            </p>
          </div>
        </div>

        <div class="custom-form-control">
          <label>CVV</label>
          <input
            class="form-control"
            :class="[$v.card.cvc.$error ? 'form-control-invalid' : '']"
            type="number"
            placeholder="Ex: 123"
            v-mask="['###', '####']"
            v-model="$v.card.cvc.$model"
          />
          <div v-if="$v.card.cvc.$error">
            <p class="error" v-if="!$v.card.cvc.required">Campo obrigatório</p>
          </div>

          <div v-if="$v.card.cvc.$error">
            <p
              class="error"
              v-if="!$v.card.cvc.cvcIsValid && card.cvc.length >= 3"
            >
              CVC inválido
            </p>
          </div>
        </div>
      </div>

      <button
        class="button3"
        :class="[canSaveCreditCard ? 'button-disabled' : '']"
        @click.prevent="saveCreditCard()"
        :disabled="canSaveCreditCard"
      >
        Salvar cartão
      </button>
    </form>
  </div>
</template>

<script>
import { userMethods } from "./../state/helpers";
import { required, between } from "vuelidate/lib/validators";
import { moreThan18y } from "./../utils/dates/format";
import { MoipValidator } from "moip-sdk-js";
import { cpf } from "./../utils/validations/cpf";

export default {
  name: "CreditCard",
  props: { title: { type: String, default: "" } },
  data() {
    return {
      loading: false,
      card: {
        nickname: "",
        number: "",
        cvc: "",
        expiration: "",
        holder_name: "",
        holder_cpf: "",
        holder_birthdate: "",
        area_code: "",
        phone_number: ""
      },
      hasUpdated: false
    };
  },
  validations: {
    card: {
      nickname: { required },
      number: {
        required,
        creditCardNumber: function(creditCardNumber) {
          return MoipValidator.isValidNumber(creditCardNumber);
        }
      },
      cvc: {
        required,
        cvcIsValid: function(cvc) {
          if (MoipValidator.isValidNumber(this.card.number))
            return MoipValidator.isSecurityCodeValid(this.card.number, cvc);

          return false;
        }
      },
      expiration: {
        required,
        validExpirationDate: function(value) {
          if (value.length == 5) {
            const [month, year] = value.split("/");
            return MoipValidator.isExpiryDateValid(month, year);
          }

          return false;
        }
      },
      holder_name: { required },
      area_code: { required },
      phone_number: { required },
      holder_cpf: { required, cpf },
      holder_birthdate: {
        required,
        minAge: function(value) {
          if (value.length == 10) return moreThan18y(value) > 18;

          return false;
        }
      }
    }
  },
  methods: {
    ...userMethods,
    async saveCreditCard() {
      if (!this.$v.card.$invalid) {
        try {
          this.loading = true;
          const token = await this.tokenizeCreditCard(this.card);
          const credit_card_payload = {
            nickname: this.card.nickname,
            token: token.token,
            set_as_default: false
          };
          const { data } = await this.addCreditCard(credit_card_payload);
          this.hasUpdated = true;
          this.$emit("pushNewCreditCard", data);
          this.$v.$reset();
          this.clearCard();
        } catch (error) {
          swal.fire({
            icon: "error",
            title: "Erro ao processar a transação",
            text: "Tente novamente mais tarde!"
          });
        } finally {
          this.loading = false;
        }
      }
    },
    closeSuccessMessage() {
      this.hasUpdated = false;
    },
    clearCard() {
      this.card = {
        nickname: "",
        number: "",
        cvc: "",
        expiration: "",
        holder_name: "",
        holder_cpf: "",
        holder_birthdate: ""
      };
    }
  },
  computed: {
    canSaveCreditCard() {
      return this.$v.card.$invalid || this.loading;
    },
    feedbackMessage() {
      return "Cartao cadastrado com sucesso!";
    },
    userHasAddress() {
      return !!this.$store.state.user.currentUser.address.id;
    }
  }
};
</script>
